import axios from "axios";

export const SET_USER_TOKEN = (state, accessToken) => {
  state.authToken = accessToken;
};

export const SET_EVENT_POS = (state, pos) => {
  state.pos = pos;
};

export const SET_EVENT_PDV = (state, pdv) => {
  state.pdv = pdv;
};

export const SET_LOGGED_USER = (state, data) => {
  state.loggedUser = data;
};

export const SET_LOGINPOS_DATA = (state, data) => {
  state.loginPosData = data;
};

export const SET_HEADERS = (state, data) => {
  axios.defaults.headers.common["pdv"] = data.pdv;
  axios.defaults.headers.common["CHECKOUT"] = "one-checkout";
  axios.defaults.headers.common["pos"] = data.pos;
  axios.defaults.headers.common["Authorization"] = data.token;
  axios.defaults.headers.common["TERMINAL"] = localStorage.getItem("ht");
};

export const SET_EVENT_ID = (state, data) => {
  state.eventId = data;
};

export const SET_WIDGET_MODE = (state, data) => {
  state.widgetMode = data;
};

export const SET_STEP = (state, data) => {
  state.step = data;
};
